import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { faBorderAll } from '@fortawesome/pro-solid-svg-icons';
import { ngxPermissionsGuard } from 'ngx-permissions';


export const limitReportOtherDetails: Route = {
  path: 'limit-report/:id',
  children: [
    {
      path: '',
      loadComponent: () =>
        import('./limit-report-other-tab.component').then(
          (mod) => mod.LimitReportOtherTabComponent,
        ),
      data: {
        translate: 'limit-reports',
        titleIcon: {
          icon: faBorderAll,
          class: 'other-icon',
        },
      },
      children: [
        { path: '', redirectTo: 'details', pathMatch: 'full' },
        {
          path: 'details',
          loadComponent: () =>
            import('../limit-report-form/limit-report-form.component').then(
              (mod) => mod.LimitReportOtherFormComponent,
            ),
          canDeactivate: [CanDeactivateGuard],
          data: {
            label: 'limit-reports.tab.DETAILS',
          },
        },
        {
          path: 'settings',
          loadComponent: () =>
            import(
              '@backoffice-frontend/limit-report/configuration/ui-configuration'
            ).then((mod) => mod.LimitReportSettingsFormComponent),
          canDeactivate: [CanDeactivateGuard],
          data: {
            label: 'limit-reports.tab.COMMON_REPORT_SETTINGS',
            disable: true,
          },
        },
        {
          path: 'passive',
          loadComponent: () =>
            import(
              '@backoffice-frontend/limit-report/configuration/ui-configuration'
            ).then((mod) => mod.LimitReportSettingPassiveComponent),
          canActivate: [ngxPermissionsGuard],
          data: {
            label: 'customer-pools.tab.SETTINGS_PASSIVE',
            disable: true,
          },
        },
        {
          path: 'dynamic_limit_a1',
          loadComponent: () =>
            import(
              '@backoffice-frontend/limit-report/configuration/ui-configuration'
            ).then((mod) => mod.LimitReportDynamicLimitFormComponent),
          canDeactivate: [CanDeactivateGuard],
          data: {
            label: 'limit-reports.tab.DYNAMIC_REPORT_SETTINGS_A1',
            disable: true,
          },
        },
        {
          path: 'dynamic_limit_a2',
          loadComponent: () =>
            import(
              '@backoffice-frontend/limit-report/configuration/ui-configuration'
            ).then((mod) => mod.LimitReportConfigurationComponent),
          canDeactivate: [CanDeactivateGuard],
          data: {
            label: 'limit-reports.tab.TECHNICAL_INDICATORS_A2',
            disable: true,
          },
        },
        {
          path: 'other_report_settings',
          loadComponent: () =>
            import(
              '@backoffice-frontend/limit-report/configuration/ui-configuration'
            ).then((mod) => mod.LimitReportOtherSettingsFormComponent),
          canDeactivate: [CanDeactivateGuard],
          data: {
            label: 'limit-reports.tab.OTHER_REPORT_SETTINGS',
            disable: true,
          },
        },
        {
          path: 'positions',
          loadComponent: () =>
            import(
              '../limit-report-other-positions-shell/limit-report-other-positions-shell.component'
            ).then((mod) => mod.LimitReportOtherPositionsShellComponent),
          data: {
            label: 'limit-reports.tab.POSITIONS',
            disable: true,
          },
          children: [
            {
              path: 'preview/:positionId',
              loadComponent: () =>
                import(
                  '../limit-report-legacy-other-position-preview-redirect/limit-report-legacy-other-position-preview-redirect.component'
                ).then(
                  (m) => m.LimitReportLegacyOtherPositionPreviewRedirectComponent,
                ),
            },
            {
              path: 'standard',
              loadComponent: () =>
                import(
                  '../limit-report-position-list/limit-report-position-list.component'
                ).then((mod) => mod.LimitReportPositionOtherListComponent),
              children: [
                {
                  path: 'preview/:positionId',
                  loadComponent: () =>
                    import(
                      '../limit-report-position-form/limit-report-position-form.component'
                    ).then((mod) => mod.LimitReportPositionOtherFormComponent),
                },
              ],
            },
            {
              path: 'contract',
              redirectTo: 'standard',
              pathMatch: 'full',
            },
          ],
        },
        {
          path: 'overview',
          loadComponent: () =>
            import('../limit-report-review/limit-report-review.component').then(
              (mod) => mod.LimitReportOtherReviewComponent,
            ),
          data: {
            label: 'limit-reports.tab.LIMIT_REPORTS_OVERVIEW',
            disable: true,
          },
        },
      ],
    },
  ],
};
